var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63522 2.72352C9.70848 2.59046 9.84833 2.50781 10.0002 2.50781C10.1521 2.50781 10.292 2.59046 10.3652 2.72352L12.8252 7.39352C12.944 7.61247 13.1545 7.76681 13.3991 7.81423C13.6436 7.86166 13.8965 7.7972 14.0886 7.63852L17.6527 4.58518C17.7931 4.47101 17.9911 4.46048 18.1428 4.55914C18.2945 4.65779 18.3652 4.84307 18.3177 5.01768L15.9561 13.556C15.857 13.915 15.5318 14.1647 15.1594 14.1677H4.84189C4.46918 14.1651 4.14352 13.9153 4.04439 13.556L1.68355 5.01852C1.63611 4.8439 1.70678 4.65862 1.85847 4.55997C2.01016 4.46132 2.20818 4.47184 2.34855 4.58602L5.91189 7.63935C6.10391 7.79803 6.35684 7.86249 6.60139 7.81506C6.84593 7.76764 7.05644 7.6133 7.17522 7.39435L9.63522 2.72352",
    stroke: "#FCFCFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 17.5H15.8337",
    stroke: "#FCFCFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownIcon);
export default __webpack_public_path__ + "static/media/crown-icon.8fe0b8208cc142d0cd252d078b724c6d.svg";
export { ForwardRef as ReactComponent };